export default "/steper-active-ball.ec0504ebeeee39cae3e6f12df3c72d53.svg";